import React from "react";
import Head from "next/head";
import {getPageContentType, isPagelikeContent, PageContentType} from "../../page_layouts/pageLayoutsUtils";
import {
    getCanonicalUrl,
    getDescription,
    getOgDescription,
    getOgImage,
    getOgTitle,
    getRobotsContent,
    getTitle
} from "./headUtils";

export interface Props {
    page: any
    CAEGlobalSettings: any
    currentURL: string,
    isPreview?: boolean,
    content?: any,
}

const CONTENT_TYPE = 'website';
const FORMAT_DETECTION = 'telephone=no';

function HtmlHeadContent(props: Props) {
    // If the page is a publication, news, pressrelease or event, use meta information from content instead of page
    const isPagelikeContent = getPageContentType(props.content?.content?.content?.type, props.currentURL) === PageContentType.Special;
    const currentDocumentType = isPagelikeContent ? props.content?.content?.content : props.page
    return <Head>
        <title>{getTitle(currentDocumentType)}</title>
        {props.isPreview ? <script src="/coremedia.preview.js" type="text/javascript" async/> : null}
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>
        <link rel="icon" type="image/png" href="/icon32x32.png"/>
        <link rel="canonical" href={getCanonicalUrl(currentDocumentType)} />
        <meta name="robots" content={getRobotsContent(currentDocumentType)} />
        <meta name="description" content={getDescription(currentDocumentType, props.CAEGlobalSettings)}/>
        <meta property="og:title" content={getOgTitle(props.page, props.content?.content?.content, isPagelikeContent)}/>
        <meta property="og:image" content={getOgImage(props.page, props.content?.content?.content, props.CAEGlobalSettings, isPagelikeContent)}/>
        <meta property="og:description" content={getOgDescription(props.page, props.content?.content?.content, props.CAEGlobalSettings, isPagelikeContent)}/>
        <meta property="og:url" content={props.currentURL}/>
        <meta property="og:type" content={CONTENT_TYPE}/>
        <meta name="format-detection" content={FORMAT_DETECTION}/>
        {/*Do not zoom out on mobile*/}
        <meta name="viewport" content="user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1,
        width=device-width, height=device-height"/>
    </Head>
}

export default HtmlHeadContent